import { type FC } from "react";
import { ListItem } from "./ListItem";
import { Skeleton } from "./Skeleton";
import { type AddressItem } from "$/utils/fetchGeoData";
import { FailResult } from "@/comps/FailResult";

export const ListWrapper: FC<{
  loading?: boolean;
  data?: Array<{ label: string; children: AddressItem[] }>;
  onChange: (val: AddressItem) => void;
  onReload?: () => void;
  value?: AddressItem;
  className?: string;
  error?: Error;
}> = ({ loading, data, onChange, onReload, value, error, className }) => {
  if (loading) {
    return <Skeleton />;
  }

  return error ? (
    <FailResult onReload={onReload} />
  ) : (
    <div className={className}>
      {data?.map((group) => (
        <div key={group.label}>
          {group.children.map((item, index) => (
            <ListItem
              key={item.id}
              item={item}
              onChange={onChange}
              isActived={value?.id === item.id}
              prefix={
                <div className={index === 0 ? "" : "invisible"}>
                  {group.label.toLocaleUpperCase()}
                </div>
              }
            />
          ))}
        </div>
      ))}
    </div>
  );
};
